








import { Component, Vue, Inject } from 'vue-property-decorator';
import ProductComponent from '@/moleculas/ProductComponent.vue';
import { Product } from '@/models/Product';
import { OfferService } from '@/services/OfferService';


@Component({
	components: { ProductComponent }
})
export default class AliexpressOffers extends Vue {
	items: Product[] = [];

	@Inject()
	offerService: OfferService;

	created(): void {
		this.items = this.offerService.getAliexpressOffers();
	}

	zoomProduct(item: Product): void {
		this.$emit('zoom-product', item);
	}
}
